export default __webpack_public_path__ + "static/media/icon-zbilansowana dieta.c4644012.svg";